<template>
    <section class="home-container">
        <MasterPage title="问卷统计">
            <div slot="title-icon">
                <Icon type="md-paper" />
            </div>
            <Tabs slot="paddingContent">
                <TabPane label="单项问卷统计" icon="title-icon">
                    <MasterPage style="box-shadow: none">
                        <div slot="searchContent" class="search-content-slot">
                            <Form :label-width="80">
                                <Row>
                                    <Col span="10">
                                    <FormItem label="问卷名称：">
                                        <Cascader :transfer="true" :clearable="false" :render-format="formatQuestionnaire" :data="questionnaireAllList" v-model="selectQuestionnaire.name"></Cascader>
                                    </FormItem>
                                    </Col>
                                    <Col span="10">
                                    <FormItem label="时间段：">
                                        <!--<DatePicker transfer type="daterange"-->
                                                    <!--confirm format="yyyy-MM-dd HH:mm" placement="bottom-end" placeholder="请选择时间段" style="width: 100%"></DatePicker>-->
                                        <DatePicker :transfer="true" v-model="selectQuestionnaire.dataTime" type="datetimerange" format="yyyy-MM-dd HH:mm" placeholder="请选择时间段" style="width: 100%"></DatePicker>
                                    </FormItem>
                                    </Col>
                                    <Col span="4" style="display: flex;justify-content: center;">
                                    <Button type="info" icon="ios-search" style="margin-left: 10px" :loading="questionnaireResultLoading" @click="findCountResult">查询</Button>
                                    <Button type="info" icon="ios-search" style="margin-left: 10px" :loading="questionnaireResultLoading" @click="exportResult">导出</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div v-if="questionnaireCountResult != ''" slot="paddingContent" style="display: flex;justify-content: center">
                            <div style="width: 80%">
                                <Card>
                                    <p style="text-align: center;font-size: 26px;font-weight: bold;margin: 30px 0">
                                        {{questionnaireCountResult.name}}
                                        <Divider>
                                            <span style="font-size: 14px">总答题人数：{{questionnaireTotalCount}}人</span>
                                        </Divider>

                                    </p>
                                    <div style="margin-top: 60px" v-for="(question,index) in questionnaireCountResult.questionVOList" :key="question.id">
                                        <Divider orientation="left" style="margin: 20px 0">
                                            <span style="font-size: 20px;color: #3c3c3c">
                                                {{question.index}}、{{question.text}}
                                            </span>
                                        </Divider>
                                        <Table :columns="columnsResult" :data="question.optionList">
                                            <div slot="header">
                                                <p style="text-align: center">
                                                    题目类型：{{question.type}}题
                                                    （<span style="color: red">{{question.required?'必答':'非必答'}}</span>）
                                                </p>
                                            </div>
                                            <div slot="footer">
                                                <p style="text-align: center">本题有效答题人数：{{question.answerTimes}}人</p>
                                            </div>
                                        </Table>
                                        <div style="margin: 10px 0;text-align: end">
                                            <Button label="small" type="primary" class="my_button"
                                                    @click="chartColumn_button(question)" :ghost='question.echarts==0?false:true'>
                                                <i class="iconfont">&#xe619;</i>
                                                柱状图
                                            </Button>
                                            <Button label="small" type="primary" class="my_button"
                                                    @click="chartPie_button(question)" :ghost='question.echarts==1?false:true'>
                                                <i class="iconfont">&#xe614;</i>
                                                饼状图
                                            </Button>
                                            <Button label="small" type="primary" class="my_button"
                                                    @click="chartRing_button(question)" :ghost='question.echarts==2?false:true'>
                                                <i class="iconfont">&#xe612;</i>
                                                环状图
                                            </Button>
                                            <Button label="small" type="primary" class="my_button"
                                                    @click="chartStrip_button(question)" :ghost='question.echarts==3?false:true'>
                                                <i class="iconfont">&#xe617;</i>
                                                条形图
                                            </Button>
                                            <Button label="small" type="primary" class="my_button"
                                                    @click="chartZero(question)" :ghost='question.zero?false:true'>
                                                隐藏零数据
                                            </Button>
                                        </div>
                                        <div :id="'Div'+question.id">
                                            <transition name="draw">
                                            <div v-show="question.showChart" :id="'echarts'+question.id" style="width: 100%;height:400px"></div>
                                            </transition>
                                        </div>
                                    </div>
                                    <Divider style="margin-top: 40px">
                                        有效时间：{{questionnaireCountResult.startTime | dateTimeToString }}
                                        &nbsp;-&nbsp;
                                        {{questionnaireCountResult.endTime | dateTimeToString }}
                                    </Divider>
                                </Card>
                            </div>
                        </div>
                    </MasterPage>
                </TabPane>
                <TabPane label="用户填写统计" icon="ios-contact">
                    <MasterPage style="box-shadow: none">
                        <div slot="searchContent" class="search-content-slot">
                            <Form :label-width="80">
                                <Row>
                                    <Col span="10" offset="5">
                                    <FormItem label="用户问卷：">
                                        <Cascader :data="userAllList" :clearable="false" :transfer="true" v-model="userIdAndQuestionnaireId" :load-data="findAllQuestionnaireUser"></Cascader>
                                    </FormItem>
                                    </Col>
                                    <Col span="4" style="display: flex;justify-content: center;">
                                    <Button type="info" icon="ios-search" :loading="userLoading" @click="findUserHistory">查询</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div id="DivEchartsTotalNum" slot="paddingContent">
                            <div v-show="userQuestionnaire!=''" id="echartsTotalNum" style="width: 100%;height:500px"></div>
                        </div>
                    </MasterPage>
                </TabPane>
            </Tabs>
        </MasterPage>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    import echarts from 'echarts'
    import Moment from 'moment'
    export default {
        components:{
            MasterPage,
            Moment
        },
        data(){
            return{
                moment: Moment,
                questionnaireAllList: [],
                userAllList:[],
                questionnaireResultLoading:false,
                userLoading:false,
                selectQuestionnaire:{
                    name:[],
                    dataTime:[],
                },
                userIdAndQuestionnaireId:[],
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                questionnaireCountResult:"",
                questionnaireTotalCount:0,
                columnsResult:[
                    {
                        title: '选项',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (params.row.text == ''){
                                return h('span', '文本题')
                            }
                            return h('span', params.row.text)
                        }
                    },
                    {
                        title: '分值',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        key:'point',
                        sortable: true
                    },
                    {
                        title: '小计',
                        align: 'center',
                        key:'num',
                        ellipsis: true,
                        tooltip: true,
                        sortable: true
                    },
                    {
                        title: '比例',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (params.row.num == null)  params.row.num=0
                            let percent = params.row.num / this.questionnaireTotalCount * 100
                            return h('Progress',{
                                props: {
                                    percent: percent,
                                    status:'active',
                                },
                            },[h('span',percent +'%')])
                        }
                    },
                ],
                userQuestionnaire:"",
            }
        },
        created(){
            this.findAllUser()
            let obj = ['未发布','已发布','已回收']
            this.questionnaireAllList = obj.map((i)=>{
                return {value:i,label:i,disabled:true,children: [
                    {value:'已启用',label:'已启用',disabled:true,children:[]},
                        {value:'已禁用',label:'已禁用',disabled:true,children:[]}]}
            })
            this.findAllQuestionnaire()
        },
        methods:{
            formatQuestionnaire(labels, selectedData){
                if (selectedData[labels.length - 1] == undefined) return
                return selectedData[labels.length - 1].label
            },
            findAllQuestionnaire(){
                this.$http.post('questionnaire/list',{
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        msg.data.list.forEach((item)=>{
                            for (let i = 0 ;i<this.questionnaireAllList.length;i++){
                                let obj = this.questionnaireAllList[i]
                                if (item.status == obj.value){
                                    if (this.questionnaireAllList[i].disabled) {
                                        this.questionnaireAllList[i].disabled = false
                                    }
                                    let index = 0
                                    if (item.isDeleted){
                                        index = 1
                                    }
                                    this.questionnaireAllList[i].children[index].children.push({value: item.id+'',label:item.name})
                                    this.questionnaireAllList[i].children[index].disabled = false
                                }
                            }
                        })
                    }else {
                        this.$Notice.error({title:'问卷查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllQuestionnaireUser(item, callback){
                item.loading = true
                this.$http.post('questionnaire/getQuestionnaireResult',{
                    userId:item.value
                }).then(function (res) {
                    let msg = res.body
                    item.loading = false
                    if (msg.success) {
                        if (msg.data.list.length <= 0 ){
                            return item.disabled = true
                        }
                        item.disabled = false
                        let qId = []
//                        let temp = msg.data.list.map((item)=>{
//                            if (qId.indexOf())
//                            return {value:item.questionnaireId+"",label:item.questionnaireName}
//                        })
                        for (let i = 0; i < msg.data.list.length; i ++) {
                            if (qId.indexOf(msg.data.list[i].questionnaireId) < 0) {
                                item.children.push({
                                    value: msg.data.list[i].questionnaireId,
                                    label: msg.data.list[i].questionnaireName
                                })
                                qId.push(msg.data.list[i].questionnaireId)
                            }
                        }
//                        let obj = {}
//                        temp = temp.reduce(function(item, next) {
//                            obj[next.key] ? '' : obj[next.key] = true && item.push(next);
//                            return item;
//
//                        }, [])
//                        console.log('questionnaire',temp)
//                        item.children = Array.from(new Set(temp))

                    }else {
                        this.$Notice.error({title:'患者问卷查询失败',desc: msg.message});
                    }
                    callback()
                },function (res) {
                    item.loading = false
                    item.disabled = true
                    this.myError(res.body)
                    callback()
                })
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list.map((item)=>{return{value:item.id,label:item.name,children:[],loading: false,disabled:false}})
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            findCountResult(){
                this.questionnaireResultLoading = true
                this.$http.post('questionnaire/countResult',{
                    questionnaireId:this.selectQuestionnaire.name[this.selectQuestionnaire.name.length-1],
                    startTime:this.selectQuestionnaire.dataTime[0] == undefined || this.selectQuestionnaire.dataTime[0] == "" ? new Date(undefined):this.selectQuestionnaire.dataTime[0]+"",
                    endTime:this.selectQuestionnaire.dataTime[1] == undefined || this.selectQuestionnaire.dataTime[1] == "" ? new Date(undefined):this.selectQuestionnaire.dataTime[1]+"",
                }).then(function (res) {
                    this.questionnaireResultLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.questionnaireCountResult = msg.data.list[0]
                        this.questionnaireTotalCount = msg.data.count
                    }else {
                        this.$Notice.error({title:'问卷统计查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.questionnaireResultLoading = false
                    this.myError(res.body)
                })
            },
            exportResult () {
                if (this.selectQuestionnaire.name[this.selectQuestionnaire.name.length-1] == null) {
                    this.$Notice.warning({title:'请先选择问卷'});
                    return
                }
                let url = 'https://www.shengyuaninc.cn/food/questionnaire/downloadExcel?questionnaireId=' + this.selectQuestionnaire.name[this.selectQuestionnaire.name.length-1]
                console.log('date', this.selectQuestionnaire.dataTime)
                if (this.selectQuestionnaire.dataTime[0] != null && this.selectQuestionnaire.dataTime[0] !== "") {
                    url = url + '&startTime=' + this.moment(this.selectQuestionnaire.dataTime[0]).format('YYYY/MM/DD')
                }
                if (this.selectQuestionnaire.dataTime[1] != null && this.selectQuestionnaire.dataTime[1] !== "") {
//                    url = url + '&endTime=' + new Date(this.selectQuestionnaire.dataTime[1])+""
                    url = url + '&endTime=' + this.moment(this.selectQuestionnaire.dataTime[1]).format('YYYY/MM/DD')
                }
                console.log('url', url)
                window.open(url)
            },
            chartColumn_button(question){
                if (question.echarts == 0){
                    let myChart = echarts.init(document.getElementById('echarts'+question.id))
                    myChart.clear()
                    question.echarts = undefined
                    this.$set(question, 'showChart', false)
                }else {
                    this.$set(question, 'showChart', true)
                    this.$set(question, 'echarts', 0)
                    this.chartColumn(question)
                }
            },
            chartColumn(question){
                let obj = document.getElementById('echarts'+question.id)
                obj.style.width = document.getElementById('Div'+question.id).offsetWidth + "px";
                let myChart = echarts.init(obj)
                myChart.clear()
                let data = []
                for (let i = 0 ; i < question.optionList.length ; i++){
                    let item = question.optionList[i]
                    if (question.zero){
                        if (item.num !=null && item.num !=0) {
                            if (item.text == '') {
                                data.push({value: item.num, name: '文本题'})
                            }else{
                                data.push({value: item.num, name: item.text})
                            }
                        }
                    }else{
                        if (item.text == '') {
                            data.push({value: item.num, name: '文本题'})
                        }else{
                            data.push({value: item.num, name: item.text})
                        }
                    }
                }
                let option = {
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}"
                    },
                    xAxis: {
                        data: data.map((item)=>{return item.name})
                    },
                    yAxis: {},
                    series: [{
                        name: question.text,
                        type: 'bar',
                        data: data.map((item)=>{return item.value}),
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    position: 'top',
                                    textStyle: {
                                        color: 'black',
                                        fontSize: 16
                                    }
                                }
                            }
                        },
                    }]
                }
                myChart.setOption(option);
            },
            chartPie_button(question){
                if (question.echarts == 1){
                    let myChart = echarts.init(document.getElementById('echarts'+question.id))
                    myChart.clear()
                    question.echarts = undefined
                    this.$set(question, 'showChart', false)
                }else {
                    this.$set(question, 'showChart', true)
                    this.$set(question, 'echarts', 1)
                    this.chartPie(question)
                }
            },
            chartPie(question){
                let obj = document.getElementById('echarts'+question.id)
                obj.style.width = document.getElementById('Div'+question.id).offsetWidth + "px";
                let myChart = echarts.init(obj)
                myChart.clear()
                let data = []
                for (let i = 0 ; i < question.optionList.length ; i++){
                    let item = question.optionList[i]
                    if (question.zero){
                        if (item.num !=null && item.num !=0) {
                            if (item.text == '') {
                                data.push({value: item.num, name: '文本题'})
                            }else{
                                data.push({value: item.num, name: item.text})
                            }
                        }
                    }else{
                        if (item.text == '') {
                            data.push({value: item.num, name: '文本题'})
                        }else{
                            data.push({value: item.num, name: item.text})
                        }
                    }
                }
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series: [
                        {
                            name: question.text,
                            type: 'pie',
                            data: data,
                            radius: '75%',
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                normal: {
                                    label: {
                                        show: true,
                                        formatter:'{b}:{c}({d}%)',
                                    },
                                    labelLine :{show:true}
                                }
                            },
                        }
                    ]
                }
                myChart.setOption(option);
            },
            chartRing_button(question){
                if (question.echarts == 2){
                    let myChart = echarts.init(document.getElementById('echarts' + question.id))
                    myChart.clear()
                    question.echarts = undefined
                    this.$set(question, 'showChart', false)
                }else {
                    this.$set(question, 'showChart', true)
                    this.$set(question, 'echarts', 2)
                    this.chartRing(question)
                }
            },
            chartRing(question){
                let obj = document.getElementById('echarts'+question.id)
                obj.style.width = document.getElementById('Div'+question.id).offsetWidth + "px";
                let myChart = echarts.init(obj)
                myChart.clear()
                let data = []
                for (let i = 0 ; i < question.optionList.length ; i++){
                    let item = question.optionList[i]
                    if (question.zero){
                        if (item.num !=null && item.num !=0) {
                            if (item.text == '') {
                                data.push({value: item.num, name: '文本题'})
                            }else{
                                data.push({value: item.num, name: item.text})
                            }
                        }
                    }else{
                        if (item.text == '') {
                            data.push({value: item.num, name: '文本题'})
                        }else{
                            data.push({value: item.num, name: item.text})
                        }
                    }
                }
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series: [
                        {
                            name: question.text,
                            type: 'pie',
                            data: data,
                            radius: ['55%', '75%'],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                normal: {
                                    label: {
                                        show: true,
                                        formatter:'{b}:{c}({d}%)',
                                    },
                                    labelLine :{show:true}
                                }
                            }
                        }
                    ]
                }
                myChart.setOption(option);
            },
            chartStrip_button(question){
                if (question.echarts == 3){
                    question.echarts = undefined
                    let myChart = echarts.init(document.getElementById('echarts'+question.id))
                    myChart.clear()
                    this.$set(question, 'showChart', false)
                }else {
                    this.$set(question, 'showChart', true)
                    this.$set(question, 'echarts', 3)
                    this.chartStrip(question)
                }
            },
            chartStrip(question){
                let obj = document.getElementById('echarts'+question.id)
                obj.style.width = document.getElementById('Div'+question.id).offsetWidth + "px";
                let myChart = echarts.init(obj)
                myChart.clear()
                let data = []
                for (let i = 0 ; i < question.optionList.length ; i++){
                    let item = question.optionList[i]
                    if (question.zero){
                        if (item.num !=null && item.num !=0) {
                            if (item.text == '') {
                                data.push({value: item.num, name: '文本题'})
                            }else{
                                data.push({value: item.num, name: item.text})
                            }
                        }
                    }else{
                        if (item.text == '') {
                            data.push({value: item.num, name: '文本题'})
                        }else{
                            data.push({value: item.num, name: item.text})
                        }
                    }
                }
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}"
                    },
                    xAxis: {},
                    yAxis: {
                        data: data.map((item) => {
                            return item.name
                        })
                    },
                    series: [
                        {
                            name: question.text,
                            type: 'bar',
                            data: data.map((item) => {
                                return item.value
                            }),
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'right',
                                        textStyle: {
                                            color: 'black',
                                            fontSize: 16
                                        }
                                    }
                                }
                            },
                        }
                    ]
                }
                myChart.setOption(option);
            },
            chartZero(question){
                if (question.zero){
                    this.$set(question, 'zero', false)
                } else{
                    this.$set(question, 'zero', true)
                }
                switch (question.echarts) {
                    case 0:
                        this.chartColumn(question)
                        break;
                    case 1:
                        this.chartPie(question)
                        break;
                    case 2:
                        this.chartRing(question)
                        break;
                    case 3:
                        this.chartStrip(question)
                        break;
                }
            },
            findUserHistory(){
                if (this.userIdAndQuestionnaireId.length < 2 ){
                    return this.$Message.warning('请正确选择患者问卷');
                }
                this.userLoading = true
                this.$http.post('questionnaire/getUserHistory',{
                    userId:this.userIdAndQuestionnaireId[0],
                    questionnaireId:this.userIdAndQuestionnaireId[this.userIdAndQuestionnaireId.length-1],
                }).then(function (res) {
                    this.userLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.userQuestionnaire = msg.data
                        this.chartLine(msg.data)
                    }else {
                        this.$Notice.error({title:'问卷统计查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.userLoading = false
                    this.myError(res.body)
                })
            },
            chartLine(data){
                let obj = document.getElementById('echartsTotalNum')
                obj.style.width = document.getElementById('DivEchartsTotalNum').offsetWidth + "px";
                let myChart = echarts.init(obj)
                myChart.clear()
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}:总分{c}"
                    },
                    xAxis: {
                        data: data.x.map((item)=>{
                            let time = new Date(item)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let h = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return y+'-'+m+'-'+d+' '+h+':'+mm+':'+s;
                        })
                    },
                    yAxis: {},
                    series: [{
                        data: data.y,
                        type: 'line'
                    }],
                    dataZoom: [
                        {
                            type: 'slider',
                            show: true,
                            xAxisIndex: [0],
                            start: 0,
                            end: 100
                        },
                        {
                            type: 'slider',
                            show: true,
                            yAxisIndex: [0],
                            left: '93%',
                            start: 0,
                            end: 100
                        },
                        {
                            type: 'inside',
                            xAxisIndex: [0],
                            start: 0,
                            end: 100
                        },
                    ],
                    grid: {
                        top: 30,
                        bottom: 60
                    },
                }
                myChart.setOption(option);
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    @font-face {
        font-family: 'iconfont';  /* project id 1253004 */
        src: url('//at.alicdn.com/t/font_1253004_7fpp1opp0vg.eot');
        src: url('//at.alicdn.com/t/font_1253004_7fpp1opp0vg.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1253004_7fpp1opp0vg.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1253004_7fpp1opp0vg.woff') format('woff'),
        url('//at.alicdn.com/t/font_1253004_7fpp1opp0vg.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1253004_7fpp1opp0vg.svg#iconfont') format('svg');
    }

    .iconfont{
        font-family:"iconfont" !important;
        font-size:12px;font-style:normal;
        padding-right: 5px;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
    }

    .home-container{

    }

    .my_button{
        margin: 0 5px;
        padding: 3px 10px
    }

    .draw-leave-active,.draw-enter-active{
        transition:  all 0.5s ease;
    }
    .draw-leave-to,.draw-enter{
        height:0px !important;
    }
    .draw-leave,.draw-enter-to{
        height: 100%;
    }
</style>
